export default __webpack_public_path__ + "static/media/17.9f4f8dc9.png";